import React, { useEffect, useState } from "react";
import { RiArrowDownSLine, RiCloseLine, RiMenu3Line } from "react-icons/ri";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/logos/thrive.jpg";
import "./navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("nav-menu-open", menuOpen);
    return () => document.body.classList.remove("nav-menu-open");
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-navbar ${isScrolled ? "is-scrolled" : ""}`}>
      <div className="site-navbar__inner">
        <Link
          to="/"
          className="site-navbar__brand"
          aria-label="Thrive Holdings home"
          onClick={closeMenu}
        >
          <img src={logo} alt="Thrive Holdings Limited" />
        </Link>

        <nav className="site-navbar__desktop" aria-label="Primary navigation">
          <NavLink to="/group">Who we are</NavLink>
          <NavLink to="/what-we-do">What we do</NavLink>

          <div className="site-navbar__dropdown">
            <button type="button">
              Our companies <RiArrowDownSLine aria-hidden="true" />
            </button>
            <div className="site-navbar__dropdown-menu">
              <a
                href="https://www.insurance.thrivenig.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Thrive Insurance Brokers
              </a>
              <a
                href="https://www.travels.thrivenig.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Thrive Travels &amp; Tours
              </a>
            </div>
          </div>

          <div className="site-navbar__dropdown">
            <button type="button">
              Leadership <RiArrowDownSLine aria-hidden="true" />
            </button>
            <div className="site-navbar__dropdown-menu">
              <NavLink to="/board-of-directors">Board of Directors</NavLink>
              <NavLink to="/management-team">Management Team</NavLink>
            </div>
          </div>

          <NavLink to="/career">Careers</NavLink>
        </nav>

        <Link className="site-navbar__contact" to="/contact">
          Contact us
        </Link>

        <button
          className="site-navbar__toggle"
          type="button"
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? (
            <RiCloseLine aria-hidden="true" />
          ) : (
            <RiMenu3Line aria-hidden="true" />
          )}
        </button>
      </div>

      <nav
        className={`site-navbar__mobile ${menuOpen ? "is-open" : ""}`}
        aria-label="Mobile navigation"
      >
        <NavLink to="/group" onClick={closeMenu}>
          Who we are
        </NavLink>
        <NavLink to="/what-we-do" onClick={closeMenu}>
          What we do
        </NavLink>
        <NavLink to="/board-of-directors" onClick={closeMenu}>
          Board of Directors
        </NavLink>
        <NavLink to="/management-team" onClick={closeMenu}>
          Management Team
        </NavLink>
        <NavLink to="/career" onClick={closeMenu}>
          Careers
        </NavLink>
        <div className="site-navbar__mobile-companies">
          <span>Our companies</span>
          <a
            href="https://www.insurance.thrivenig.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMenu}
          >
            Thrive Insurance Brokers Limited
          </a>
          <a
            href="https://www.travels.thrivenig.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMenu}
          >
            Thrive Travels &amp; Tours Limited
          </a>
        </div>
        <NavLink
          className="site-navbar__mobile-contact"
          to="/contact"
          onClick={closeMenu}
        >
          Contact us
        </NavLink>
      </nav>
    </header>
  );
};

export default Navbar;
